var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.dataLoaded)?_c('Chart',{attrs:{"chartID":"cognitive-function-chart","type":"line","labels":_vm.labels,"datasets":_vm.datasets}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }